import { createMuiTheme } from "@material-ui/core/styles";
import type {} from "@material-ui/lab/themeAugmentation";

export const white = "#FFFFFF";
const theme = createMuiTheme({
  palette: {
    primary: { main: "#27447C", dark: "#1F6993", light: " #7A7A7A" },
    text: {
      primary: "#000000",
    },
    action: {
      active: "#7FB9D4",
    },
    background: {
      default: "#F9FDFD",
    },
    secondary: {
      main: "#7A7A7A",
    },
  },
});
export default theme;
